import styled, { keyframes } from 'styled-components'

// Paleta local (Bilheteria Digital — azul), mobile-first.
export const C = {
  paper: '#EEF2F9',
  brand: '#1B4DD8',
  brandDeep: '#0E356D',
  brandSoft: '#E7EEFF',
  ink: '#10203A',
  ink2: '#54637E',
  ink3: '#8494AE',
  line: '#E2E8F2',
  surface: '#FFFFFF',
  surface2: '#F5F7FB',
  surface3: '#EAF0FA',
  ok: '#12A150',
  okSoft: '#E3F5EA',
  warn: '#C77700',
  warnSoft: '#FBF0DD',
  bad: '#DC2626',
  badSoft: '#FBE7E7',
}

export const Wrap = styled.div`
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 16px 16px 40px;
  color: ${C.ink};
  box-sizing: border-box;
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`

export const EventName = styled.div`
  min-width: 0;
  h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 750;
    letter-spacing: -0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    font-size: 11px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${C.brand};
    font-weight: 700;
  }
`

export const DevicePill = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${C.surface2};
  border: 1px solid ${C.line};
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 10.5px;
  font-weight: 800;
  color: ${C.ink2};
  flex: none;
`

export const OccasionBar = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${C.surface};
  border: 1px solid ${C.line};
  border-radius: 12px;
  padding: 11px 14px;
  margin-bottom: 18px;
  box-shadow: 0 1px 2px rgba(16, 32, 58, 0.05);
  .lab {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${C.ink2};
    font-weight: 700;
  }
  select {
    margin-left: auto;
    border: none;
    background: transparent;
    color: ${C.ink};
    font: inherit;
    font-size: 14.5px;
    font-weight: 650;
    text-align: right;
    cursor: pointer;
  }
`

export const ScanButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 28px 20px;
  border: none;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(150deg, ${C.brand}, ${C.brandDeep});
  box-shadow: 0 10px 26px -8px rgba(27, 77, 216, 0.5);
  transition: filter 0.16s, transform 0.1s;
  &:hover {
    filter: brightness(1.05);
  }
  &:active {
    transform: scale(0.985);
  }
  .ico {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.16);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  strong {
    font-size: 19px;
    font-weight: 750;
  }
  span {
    font-size: 13px;
    opacity: 0.85;
    margin-top: -4px;
  }
`

export const Or = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${C.ink3};
  font-size: 12px;
  font-weight: 600;
  margin: 18px 2px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  &::before,
  &::after {
    content: '';
    height: 1px;
    background: ${C.line};
    flex: 1;
  }
`

export const SearchField = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${C.surface};
  border: 1.5px solid ${C.line};
  border-radius: 12px;
  padding: 13px 14px;
  transition: border-color 0.16s, box-shadow 0.16s;
  &:focus-within {
    border-color: ${C.brand};
    box-shadow: 0 0 0 4px ${C.brandSoft};
  }
  input {
    border: none;
    background: transparent;
    flex: 1;
    min-width: 0;
    font: inherit;
    font-size: 15px;
    color: ${C.ink};
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: ${C.ink3};
    }
  }
`

export const Detected = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 9px 4px 0;
  min-height: 18px;
  font-size: 12.5px;
  color: ${C.ink2};
  b {
    color: ${C.brand};
    font-weight: 700;
  }
`

export const Hint = styled.p`
  font-size: 12px;
  color: ${C.ink3};
  margin: 9px 4px 0;
  line-height: 1.5;
`

export const SectionTitle = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 26px 2px 12px;
  h3 {
    margin: 0;
    font-size: 13px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${C.ink2};
    font-weight: 750;
  }
  .count {
    font-size: 12px;
    color: ${C.ink3};
    font-weight: 600;
  }
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const HistoryToggle = styled.button<{ $open?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  background: ${C.surface};
  border: 1px solid ${C.line};
  border-radius: 12px;
  padding: 12px 14px;
  margin: 26px 0 ${(p) => (p.$open ? '12px' : '0')};
  cursor: pointer;
  text-align: left;
  h3 {
    margin: 0;
    font-size: 13px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${C.ink2};
    font-weight: 750;
  }
  .count {
    font-size: 12px;
    color: ${C.ink3};
    font-weight: 600;
  }
  .chev {
    margin-left: auto;
    color: ${C.ink3};
    display: flex;
    transition: transform 0.18s;
    transform: rotate(${(p) => (p.$open ? '90deg' : '0deg')});
  }
`

export const Row = styled.button`
  display: flex;
  align-items: center;
  gap: 13px;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  background: ${C.surface};
  border: 1px solid ${C.line};
  border-radius: 12px;
  padding: 12px 13px;
  cursor: pointer;
  transition: transform 0.08s, border-color 0.16s;
  &:hover {
    border-color: ${C.brand}55;
  }
  &:active {
    transform: translateY(1px);
  }
  .time {
    font-size: 14px;
    font-weight: 750;
    font-variant-numeric: tabular-nums;
    flex: none;
    width: 42px;
  }
  .ico {
    width: 38px;
    height: 38px;
    border-radius: 11px;
    background: ${C.surface3};
    color: ${C.brand};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }
  .who {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
  .nm {
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mt {
    font-size: 12.5px;
    color: ${C.ink2};
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .chev {
    color: ${C.ink3};
    flex: none;
  }
`

export const Chip = styled.span<{ tone: 'ok' | 'warn' | 'bad' }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 750;
  padding: 4px 9px;
  border-radius: 999px;
  flex: none;
  background: ${(p) =>
    p.tone === 'ok' ? C.okSoft : p.tone === 'warn' ? C.warnSoft : C.badSoft};
  color: ${(p) =>
    p.tone === 'ok' ? C.ok : p.tone === 'warn' ? C.warn : C.bad};
  .d {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
`

export const TicketCard = styled.button<{ $selected?: boolean }>`
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  background: ${(p) => (p.$selected ? C.brandSoft : C.surface)};
  border: 1.5px solid ${(p) => (p.$selected ? C.brand : C.line)};
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
  transition: transform 0.08s, border-color 0.16s, background 0.16s;
  &:hover {
    border-color: ${(p) => (p.$selected ? C.brand : `${C.brand}55`)};
  }
  &:active {
    transform: translateY(1px);
  }
  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .nm {
    font-size: 15px;
    font-weight: 750;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 9px 14px;
    margin-top: 12px;
  }
  .k {
    font-size: 10.5px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${C.ink3};
    font-weight: 700;
  }
  .v {
    font-size: 13.5px;
    font-weight: 600;
    color: ${C.ink};
    margin-top: 2px;
  }
`

/* ---------- Validação em lote ---------- */
export const BatchBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: ${C.surface};
  border-top: 1px solid ${C.line};
  box-shadow: 0 -6px 20px rgba(16, 32, 58, 0.08);
  > div {
    max-width: 480px;
    margin: 0 auto;
  }
`

export const ConfirmBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(10, 20, 38, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
  @media (min-width: 520px) {
    align-items: center;
  }
`

export const ConfirmCard = styled.div`
  width: 100%;
  max-width: 440px;
  background: ${C.surface};
  border-radius: 18px;
  padding: 22px 20px 18px;
  box-shadow: 0 20px 50px rgba(16, 32, 58, 0.3);
  h3 {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 800;
    color: ${C.ink};
  }
  p {
    margin: 0 0 18px;
    font-size: 14.5px;
    color: ${C.ink2};
    line-height: 1.5;
  }
  .row {
    display: flex;
    gap: 10px;
  }
`

export const BackBar = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: ${C.ink2};
  font: inherit;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  padding: 4px 0;
  margin-bottom: 4px;
`

/* ---------- Resultado ---------- */
const pop = keyframes`
  from { transform: scale(.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`

export const ResultHero = styled.div<{ tone: 'valid' | 'used' | 'bad' }>`
  padding: 20px 24px 16px;
  text-align: center;
  color: #fff;
  border-radius: 18px 18px 0 0;
  background: ${(p) =>
    p.tone === 'valid'
      ? `linear-gradient(160deg, ${C.ok}, #0b7a3b)`
      : p.tone === 'used'
      ? `linear-gradient(160deg, ${C.warn}, #9a5b00)`
      : `linear-gradient(160deg, ${C.bad}, #a11414)`};
  .badge {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    margin: 0 auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${pop} 0.4s cubic-bezier(0.2, 0.9, 0.3, 1.3);
  }
  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }
  .sub {
    margin: 5px 0 0;
    font-size: 13px;
    opacity: 0.92;
    font-variant-numeric: tabular-nums;
  }
`

export const ResultCard = styled.div`
  margin: 0 8px;
  background: ${C.surface};
  border: 1px solid ${C.line};
  border-top: none;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 8px 24px rgba(16, 32, 58, 0.08);
  .rrow {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border-bottom: 1px solid ${C.line};
    &:last-child {
      border-bottom: none;
    }
  }
  .ico {
    width: 30px;
    height: 30px;
    border-radius: 9px;
    background: ${C.surface3};
    color: ${C.brand};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }
  .k {
    font-size: 10.5px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${C.ink3};
    font-weight: 700;
  }
  .v {
    font-size: 14.5px;
    font-weight: 700;
    color: ${C.ink};
    margin-top: 1px;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 8px 8px;
`

export const Btn = styled.button<{ variant?: 'primary' | 'ghost' }>`
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  padding: 13px;
  border-radius: 14px;
  font: inherit;
  font-weight: 750;
  font-size: 15.5px;
  cursor: pointer;
  transition: filter 0.16s, transform 0.08s;
  &:active {
    transform: translateY(1px);
  }
  ${(p) =>
    p.variant === 'ghost'
      ? `background:${C.surface2}; color:${C.ink}; border:1px solid ${C.line};`
      : `background:${C.brand}; color:#fff; border:none; &:hover{filter:brightness(1.06);}`}
`

export const Empty = styled.div`
  text-align: center;
  color: ${C.ink2};
  padding: 40px 20px;
  font-size: 14.5px;
`

/* ---------- Filtro de ingressos (por setor) ---------- */
export const ConfigRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 18px;
`

export const HelpButton = styled.button`
  flex: none;
  width: 48px;
  border: 1px solid ${C.line};
  border-radius: 12px;
  background: ${C.surface};
  color: ${C.brand};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: ${C.brand}55;
  }
`

export const ConfigBar = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  background: ${C.surface};
  border: 1px solid ${C.line};
  border-radius: 12px;
  padding: 11px 14px;
  cursor: pointer;
  text-align: left;
  .lab {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${C.ink2};
    font-weight: 700;
  }
  .val {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13.5px;
    font-weight: 650;
    color: ${C.brand};
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const FilterOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: ${C.paper};
  display: flex;
  flex-direction: column;
`

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid ${C.line};
  background: ${C.surface};
  flex: none;
  h3 {
    margin: 0;
    font-size: 17px;
    font-weight: 750;
    flex: 1;
  }
  .x {
    width: 38px;
    height: 38px;
    border-radius: 11px;
    border: none;
    background: ${C.surface2};
    color: ${C.ink};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`

export const FilterBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 6px 14px 20px;
  -webkit-overflow-scrolling: touch;
`

export const FilterRow = styled.button<{ $level?: number; $master?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  padding: 13px 8px;
  padding-left: ${(p) => 8 + (p.$level ?? 0) * 22}px;
  border-bottom: 1px solid ${(p) => (p.$master ? C.line : C.surface2)};
  .label {
    flex: 1;
    min-width: 0;
    font-size: ${(p) => ((p.$level ?? 0) >= 2 ? '14px' : '15px')};
    font-weight: ${(p) =>
      p.$master
        ? 800
        : (p.$level ?? 0) === 0
        ? 750
        : (p.$level ?? 0) === 1
        ? 650
        : 500};
    color: ${C.ink};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .count {
    font-size: 12px;
    color: ${C.ink3};
    font-weight: 600;
    flex: none;
  }
`

export const CheckBox = styled.span<{ $state: 'on' | 'off' | 'partial' }>`
  width: 22px;
  height: 22px;
  border-radius: 6px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 2px solid ${(p) => (p.$state === 'off' ? C.line : C.brand)};
  background: ${(p) => (p.$state === 'off' ? 'transparent' : C.brand)};
`

export const FilterFooter = styled.div`
  flex: none;
  padding: 14px 16px calc(14px + env(safe-area-inset-bottom));
  border-top: 1px solid ${C.line};
  background: ${C.surface};
`
